import { Project } from '../types/project';
import { fetcher } from '../utils/fetcher';

const API_URL = '/api/v1/projects';

export const getProjects = async (programmeId?: string): Promise<Project[]> => {
    const params = new URLSearchParams();
    if (programmeId) {
        params.append('programme_id', programmeId);
    }
    const url = `${API_URL}/read${params.toString() ? `?${params.toString()}` : ''}`;
    const response = await fetcher(url);
    return response;
};

export const getProjectById = async (projectId: string): Promise<Project> => {
    const response = await fetcher(`${API_URL}/read/${projectId}`);
    return response;
};

export const createProject = async (projectData: Omit<Project, 'id' | 'created_at' | 'updated_at'>): Promise<Project> => {
    const response = await fetcher(`${API_URL}/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(projectData),
    });
    return response;
};

export const updateProject = async (projectId: string, projectData: Partial<Project>): Promise<Project> => {
    const response = await fetcher(`${API_URL}/update/${projectId}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(projectData),
    });
    return response;
};

export const deleteProject = async (projectId: string, cascade: boolean = false, reassignTo?: string): Promise<boolean> => {
    const params = new URLSearchParams();
    if (cascade) {
        params.append('cascade', 'true');
    }
    if (reassignTo !== undefined) {
        params.append('reassign_to', reassignTo.toString());
    }

    const url = `${API_URL}/delete/${projectId}${params.toString() ? `?${params.toString()}` : ''}`;

    const response = await fetcher(url, {
        method: 'DELETE',
    });
    return response;
};